import React from "react";

function ViewGaon({ data }) {
    if (!data) {
        return <div className="text-center py-4">No data available</div>;
    }

    // ✅ Status check - 1 = Active, 0 = Inactive
    const isActive = (status) => {
        return status === 1 || status === "1" || status === true;
    };

    return (
        <div className="custom-modal-body">
            <div className="model-custum">
                <h3>{data?.gaon_name || "Gaon Details"}</h3>

                <div className="view-details-grid">
                    {/* GAON NAME */}
                    <div className="view-detail-card">
                        <span>Gaon Name</span>
                        <h5>{data?.gaon_name || "N/A"}</h5>
                    </div>

                    {/* WAAD NAME */}
                    <div className="view-detail-card">
                        <span>Waad</span>
                        <h5>{data?.waad_name || "N/A"}</h5>
                    </div>

                    {/* POPULATION */}
                    <div className="view-detail-card">
                        <span>Population</span>
                        <h5>{data?.population || 0}</h5>
                    </div>

                    {/* PINCODE */}
                    <div className="view-detail-card">
                        <span>Pincode</span>
                        <h5>{data?.pincode || "N/A"}</h5>
                    </div>

                    {/* STATUS - 1 = Active, 0 = Inactive */}
                    <div className="view-detail-card">
                        <span>Status</span>
                        <h5>
                            <span className={`badge ${isActive(data?.status) ? 'bg-success' : 'bg-danger'}`}>
                                {isActive(data?.status) ? "Active" : "Inactive"}
                            </span>
                        </h5>
                    </div>

                    {/* CREATED AT */}
                    <div className="view-detail-card">
                        <span>Created At</span>
                        <h5>
                            {data?.created_at
                                ? new Date(data.created_at).toLocaleDateString('en-IN', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                })
                                : "N/A"}
                        </h5>
                    </div>

                    {/* UPDATED AT */}
                    <div className="view-detail-card">
                        <span>Updated At</span>
                        <h5>
                            {data?.updated_at
                                ? new Date(data.updated_at).toLocaleDateString('en-IN', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                })
                                : "N/A"}
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewGaon;